export var FeatureFlagType;
(function (FeatureFlagType) {
    FeatureFlagType["PATIENT_SHOP"] = "patient-shop";
    FeatureFlagType["PUSH_NOTIFICATIONS"] = "push-notifications";
    FeatureFlagType["WEBHOOKS"] = "webhooks";
    FeatureFlagType["INTEGRATIONS"] = "integrations";
    FeatureFlagType["API_KEYS"] = "api-keys";
    FeatureFlagType["PRESCRIPTIONS"] = "prescriptions";
    FeatureFlagType["APPOINTMENT_SCHEDULING"] = "appointment-scheduling";
    FeatureFlagType["TREATMENT_CATALOGUE"] = "treatment-catalogue";
    FeatureFlagType["RESSOURCES"] = "ressources";
    FeatureFlagType["DOCUMENTATION"] = "documentation";
    FeatureFlagType["PVS_BILLING"] = "pvs-billing";
    FeatureFlagType["FEATURE_RANKING"] = "feature-ranking";
    FeatureFlagType["OFFICE_ACHIEVEMENTS"] = "office-achievements";
    FeatureFlagType["CHALLENGE_MODE"] = "challenge-mode";
    FeatureFlagType["STAFF_CERTIFICATES"] = "staff-certificates";
    /**
     * §302 Abrechnung mit den gesetzlichen Krankenkassen (TM-9538).
     *
     * ⚠ Deliberately **not** `PVS_BILLING`. That flag is already live at
     * PKV/Selbstzahler practices, so hanging §302 off it would switch an
     * unfinished Abrechnungslauf on at every one of them.
     */
    FeatureFlagType["GKV_BILLING"] = "gkv-billing";
    /**
     * KI-Dokumentation (TM-9504): Diktat → Transkript → KI-Entwurf an der
     * Behandlungsdokumentation. Never stands alone — every route of the
     * `ai-documentation` module requires `DOCUMENTATION` **and** this flag.
     * Ships opted out; the release gate (Spec § 7) decides when a practice
     * gets the row.
     */
    FeatureFlagType["AI_DOCUMENTATION"] = "ai-documentation";
})(FeatureFlagType || (FeatureFlagType = {}));
//# sourceMappingURL=feature-flag-type.enum.js.map